import dataType from '../dataType';

const FirdsEsmaInstrument = {
    name: 'FirdsEsmaInstrument',
    type: dataType.string
};

export default FirdsEsmaInstrument;
